<template>
  <div class="discussion-article">
    <article class="article-set">
      <div class="article-head">
        <div class="image">
          <img :src="image" alt="" class="tablet_over_display">
          <img :src="imageSp" alt="" class="tablet_under_display">
        </div>
        <div class="article-title-wrap">
          <h4>
            {{title}}
          </h4>
          <div class="catch">
            <p class="name">
              {{name}}：
            </p>
            <p class="comment" v-html="comment">
            </p>
          </div>
        </div>
      </div>
        <slot/>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'discussion-article',
  props: {
    image: String,
    imageSp: String,
    title: String,
    name: String,
    comment: String,
  }
}
</script>

<style lang="scss" scoped>
.discussion-article {
  margin-top: 100px;
  &:nth-child(even) {
    .article-body {
      flex-direction: row-reverse;
    }
  }
}
.article-head {
  position: relative;
}
.article-title-wrap {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  color: #fff;
  font-family: 'Noto Serif JP', serif;
  text-align: center;
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;
  // @media print, screen and (max-width: 1160px) {
  @media print, screen and (max-width: 768px) {
    max-width: 90%;
  }
  h4 {
    padding: 0.8em 6em;
    border: 1px solid #fff;
    font-size: 16px;
    display: inline-block;
    margin-bottom: 0;
    // @media print, screen and (max-width: 1160px) {
    @media print, screen and (max-width: 768px) {
      padding: 0.4em 3em;
      font-size: 13px;
      margin: 0;
    }
  }
  .catch {
    text-align: left;
    display: flex;
    font-size: 22px;
    justify-content: center;
    // @media print, screen and (max-width: 1160px) {
    @media print, screen and (max-width: 768px) {
      line-height: 2em;
      font-size: 13px;
    }
  }
}
</style>
